/**
 * Ryan O'Dowd
 * 2025-05-18
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  EmailAuthProvider,
  GoogleAuthProvider,
  OAuthProvider,
  createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail,
  getAuth,
  // @TODO: getIdToken, // @TODO: this appears to be exported from firebase/auth, but for some reason, the modular api throws a "cannot read properites of null" error
  getRedirectResult,
  linkWithCredential,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithCredential,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  updateProfile,
} from 'firebase/auth';
import {
  getAnalytics,
  logEvent,
} from 'firebase/analytics';
/* @TODO: used on web?
import {
  getInitialNotification,
  getMessaging,
  getToken,
  onMessage,
  onNotificationOpenedApp,
  requestPermission,
  setBackgroundMessageHandler,
} from '@react-native-firebase/messaging';
*/
import {
  initializeApp,
} from 'firebase/app';

const env = (window.document.location.host === 'wrink.ly') ? 'prod' : (window.document.location.hostname === 'localhost' ? 'local' : 'dev'); // @TODO: better way to get env
let FIREBASE_CONFIG = {
  apiKey: 'AIzaSyAdaKn_jzLl5v2EEg5mmyaMTZ5QVEUxgsA',
  authDomain: 'wrinkly-dev.firebaseapp.com',
  projectId: 'wrinkly-dev',
  storageBucket: 'wrinkly-dev.appspot.com',
  messagingSenderId: '895606346021',
  appId: '1:895606346021:web:287e5fc66c61bb8aeb0acc',
  measurementId: 'G-8CVV86W6FZ',
};
if (env === 'prod') {
  FIREBASE_CONFIG = {
    apiKey: 'AIzaSyBtE2Xpe253lnL2MH5Y5iMgNXNiW48p3h4',
    authDomain: 'wrinkly-prod.firebaseapp.com',
    projectId: 'wrinkly-prod',
    storageBucket: 'wrinkly-prod.appspot.com',
    messagingSenderId: '182142003913',
    appId: '1:182142003913:web:5a0abd853d8ae105c9bb18',
    measurementId: 'G-YN7NJ9M7SN',
  };
}

const importedFirebase = initializeApp(FIREBASE_CONFIG);

const analytics = getAnalytics(importedFirebase);
const auth = getAuth(importedFirebase);
// @TODO: const messaging = getMessaging(importedFirebase);

const appleProvider = new OAuthProvider('apple.com');
appleProvider.setCustomParameters({
  locale: 'en', // @TODO: dynamic
});

export default {
  analytics,
  logEvent,

  auth,
  AppleAuthProvider: new OAuthProvider('apple.com'), // @TODO: this is going to be used differently from native AppleAuthProvider, so be careful (for example, AppleAuthProvider.foo vs. foo(AppleAuthProvider))
  EmailAuthProvider,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail,
  getIdToken: (user, forceRefresh = false) => user ? user.getIdToken(forceRefresh) : null,
  getRedirectResult,
  linkWithCredential,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInAnonymously: (__auth) => null,
  signInWithCredential,
  signInWithEmailAndPassword,
  signInWithPopup, // @TODO: only needed for current web? not in /app?
  signOut,
  updateProfile,

  // @TODO: are these okay for web? feel like they should be saved to back-end logs as well? {
  crashlytics: null,
  log: (__fbc, ...args) => console.log('Crashlytics mock: ', ...args), /* eslint-disable-line no-console */
  recordError: (__fbc, ...args) => console.error('Crashlytics mock: ', ...args), /* eslint-disable-line no-console */
  setAttribute: (__fbc, ...args) => console.log('Crashlytics mock: ', ...args), /* eslint-disable-line no-console */
  setUserId: (__fbc, ...args) => console.log('Crashlytics mock: ', ...args), /* eslint-disable-line no-console */
  // @TODO: are these okay for web? }

  messaging: null,
  getInitialNotification: (__fbm, ...__args) => null,
  getToken: (__fbm, ...__args) => null,
  onMessage: (__fbm, ...__args) => null,
  onNotificationOpenedApp: (__fbm, ...__args) => null,
  requestPermission: (__fbm, ...__args) => null,
  setBackgroundMessageHandler: (__fbm, ...__args) => null,
};
